module.exports = __webpack_public_path__ + "static/media/02_1440.cd64bb9f.jpeg";